import { Dialog } from "@headlessui/react";
import { ModalFoterBox } from "../../components/box/Box";
import Button from "../../components/button/Button";
import { Modal, ModalProp } from "../../components/modal/Modal";
import { UserCardCreateState } from "../../model/Systemparameters";
import { ConstMessage } from "../../config/const";

export type MaxApplicationCountModalProps = {
  toggle: () => void;
  maxApplicationCount: number;
}

export const MaxApplicationCountModal = ({
  open,
  toggle,
  closeOnClickOutside,
  maxApplicationCount,
}: ModalProp & MaxApplicationCountModalProps) => {
  return (
    <>
      <Modal
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
      >
        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all sm:w-full max-w-screen-md ">
          {
            <>
              <div className="px-2 pb-4 sm:p-4">
                <div className="text-center sm:mt-3">
                  <Dialog.Title
                    as="h3"
                    className="text-left  text-lg leading-6 text-gray-900"
                  >
                    申請
                  </Dialog.Title>
                </div>
              </div>
              <div><p>　{ConstMessage.ERR_MONTHLY_UPPER_LIMIT.replace('%1', maxApplicationCount.toString())}</p></div>
              <ModalFoterBox>
                <Button
                  className="mx-2 mt-1 text-indigo-500"
                  onClick={toggle}
                >
                  閉じる
                </Button>
              </ModalFoterBox>
            </>
          }
        </Dialog.Panel>
      </Modal>
    </>
  );
}